module.exports = __webpack_public_path__ + "img/step3.b8109a05.svg";